
import * as angular from "angular";
import * as moment from "moment";
import "./index.scss";
import { VeriCacheInterceptor } from "./services/veriCacheInterceptor.service";
import { VeriDate } from "./services/veriDate.service";
import { VeriHttpInterceptor } from "./services/veriHttpInterceptor.service";

export class Config {

    static $inject = ["$compileProvider", "$mdDateLocaleProvider", "$mdThemingProvider", "$httpProvider", "$sceDelegateProvider", "apiUrl", "reportsApiUrl", "isLocalDevelopment"];

    constructor(
        $compileProvider: angular.ICompileProvider,
        $mdDateLocaleProvider: angular.material.IDateLocaleProvider,
        $mdThemingProvider: angular.material.IThemingProvider,
        $httpProvider: angular.IHttpProvider,
        $sceDelegateProvider: angular.ISCEDelegateProvider,
        apiUrl: string,
        reportsApiUrl: string,
        isLocalDevelopment: boolean) {

        // When all components are angular, disabled angularjs theming with
        // $mdThemingProvider.disableTheming();

        $mdThemingProvider
            .theme("default")
            .primaryPalette("blue")
            .accentPalette("deep-orange");

        // set to false for production builds for speed increase
        // use angular.reloadWithDebugInfo() to load debug info
        var loadDebugInfo = isLocalDevelopment;
        if (loadDebugInfo) {
            $compileProvider.debugInfoEnabled(loadDebugInfo);
            //console.info("Debug Info Enabled");
        }

        $mdDateLocaleProvider.formatDate = (date: Date): string => {
            // Unless we use $injector at runtime we don"t have access to the veriDate service here, so lets just create it the old fashioned way
            var veriDate = new VeriDate(null);
            return veriDate.formatDate(date, "date");
        }

        $httpProvider.useApplyAsync(true);

        if (!$httpProvider.defaults.headers.get) {
            $httpProvider.defaults.headers.get = {};
        }

        //disable IE ajax request caching
        //$httpProvider.defaults.headers.get["If-Modified-Since"] = "Mon, 26 Jul 1997 05:00:00 GMT";
        //// extra
        //$httpProvider.defaults.headers.get["Cache-Control"] = "no-cache";
        ////$httpProvider.defaults.headers.get["Pragma"] = "no-cache";
        //$httpProvider.defaults.cache

        $httpProvider.interceptors.push(VeriHttpInterceptor.Factory);
        $httpProvider.interceptors.push(VeriCacheInterceptor.Factory);

        $sceDelegateProvider.resourceUrlWhitelist([
            "self",
            "http://localhost**",
            "http://m.highwaysengland.co.uk**",
            `${apiUrl}**`,
            `${reportsApiUrl}**`
        ]);

        /**
          * Angular Material dynamically generates Style tags
          * based on themes and palletes; for each ng-app.
          * Let's disable generation and <style> DOM injections. 
          */
        //$provide.constant('$MD_THEME_CSS', '/**/');

        // Configure moment
        (moment as any).updateLocale("en", {
            relativeTime: {
                future: "in %s",
                past: "%s ago",
                //s: "%d secs",
                s: "Just Now",
                m: "1 min",
                mm: "%d mins",
                h: "1 hour",
                hh: "%d hours",
                d: "1 day",
                dd: "%d days",
                M: "1 month",
                MM: "%d months",
                y: "1 year",
                yy: "%d years"
            }
        });
    }
}

//let deferredPrompt;

//window.addEventListener('beforeinstallprompt', (e) => {
//    // Prevent the mini-infobar from appearing on mobile
//    e.preventDefault();
//    // Stash the event so it can be triggered later.
//    deferredPrompt = e;
//    // Update UI notify the user they can install the PWA
//    //showInstallPromotion();
//    // Optionally, send analytics event that PWA install promo was shown.
//    console.log(`'beforeinstallprompt' event was fired.`);
//});
